"use strict";
// tslint:disable no-console
Object.defineProperty(exports, "__esModule", { value: true });
var isLocalhost = Boolean(window.location.hostname === 'localhost' ||
    // [::1] is the IPv6 localhost address.
    window.location.hostname === '[::1]' ||
    // 127.0.0.1/8 is considered localhost for IPv4.
    window.location.hostname.match(/^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/));
function register(config) {
    if (process.env.NODE_ENV === 'production' && 'serviceWorker' in navigator) {
        // The URL constructor is available in all browsers that support SW.
        var publicUrl = new URL(process.env.PUBLIC_URL, window.location.href);
        var swUrl_1 = process.env.PUBLIC_URL + "/service-worker.js";
        var initialized_1 = false;
        var init = function () {
            if (initialized_1) {
                console.log('Attempting double initialization of service worker - Blocked.');
                return;
            }
            if (isLocalhost) {
                // This is running on localhost. Let's check if a service worker still exists or not.
                checkValidServiceWorker(swUrl_1, config);
            }
            else {
                // Is not localhost. Just register service worker
                registerValidSW(swUrl_1, config);
            }
            initialized_1 = true;
        };
        if (publicUrl.origin !== window.location.origin) {
            // Our service worker won't work if PUBLIC_URL is on a different origin
            // from what our page is served on. This might happen if a CDN is used to
            // serve assets; see https://github.com/facebook/create-react-app/issues/2374
            console.log(publicUrl.origin, ' !== ', window.location.origin);
        }
        else {
            window.addEventListener('load', init);
            return init;
        }
    }
    return function () {
        console.log('Service worker or running dev build');
    };
}
exports.register = register;
function registerValidSW(swUrl, config) {
    if (config === void 0) { config = {}; }
    navigator.serviceWorker
        .register(swUrl)
        .then(function (registration) {
        //a new service worker has previously finished installing, and is now waiting
        if (registration.waiting && registration.active) {
            newerSwAvailable(registration.waiting);
        }
        else if (config.autoUpdate) {
            registration.update();
        }
        registration.onupdatefound = function () {
            var installingWorker = registration.installing;
            if (installingWorker == null) {
                return;
            }
            installingWorker.onstatechange = function () {
                if (installingWorker.state === 'installed') {
                    if (navigator.serviceWorker.controller) {
                        newerSwAvailable(installingWorker);
                    }
                    else {
                        // At this point, everything has been precached.
                        // It's the perfect time to display a
                        // "Content is cached for offline use." message.
                        console.log('Content is cached for offline use.');
                        // Execute callback
                        if (config && config.onSuccess) {
                            config.onSuccess(registration);
                        }
                    }
                }
            };
        };
        if (config.onInit) {
            config.onInit(registration);
        }
        function newerSwAvailable(sw) {
            // At this point, the updated precached content has been fetched,
            // but the previous service worker will still serve the older
            // content until all client tabs are closed.
            console.log('New content is available and will be used when all ' +
                'tabs for this page are closed. See http://bit.ly/CRA2-PWA.');
            if (config && config.onUpdate) {
                config.onUpdate(sw);
            }
        }
    })
        .catch(function (error) {
        console.error('Error during service worker registration:', error);
    });
}
function checkValidServiceWorker(swUrl, config) {
    // Check if the service worker can be found. If it can't reload the page.
    fetch(swUrl)
        .then(function (response) {
        // Ensure service worker exists, and that we really are getting a JS file.
        var contentType = response.headers.get('content-type');
        if (response.status === 404 ||
            (contentType != null && contentType.indexOf('javascript') === -1)) {
            // No service worker found. Probably a different app. Reload the page.
            navigator.serviceWorker.ready.then(function (registration) {
                registration.unregister().then(function () {
                    window.location.reload();
                });
            });
        }
        else {
            // Service worker found. Proceed as normal.
            registerValidSW(swUrl, config);
        }
    })
        .catch(function () {
        console.log('No internet connection found. App is running in offline mode.');
    });
}
function unregister() {
    if ('serviceWorker' in navigator) {
        navigator.serviceWorker.ready.then(function (registration) {
            registration.unregister();
        });
    }
}
exports.unregister = unregister;
//# sourceMappingURL=updateWorker.js.map